import { EnumProducts } from "services/caju/enums/enumProducts";
import { FORM_LOCAL_STORAGE_KEY } from "../consts";
import { FormikValues } from "formik";
import { IFormFromLocalStorage } from "../types";

export const getNextStep = (
  products: EnumProducts[],
  employeesNumber: number | ""
) => {
  if (employeesNumber && employeesNumber >= 1000) return 6

  const isMultipleWithMultibenefitsWithoutCiclos =
    products.length > 1 && !products.includes(EnumProducts.CAJU_CICLOS) && products.includes(EnumProducts.MULTIBENEFITS);

  const isMultibenefitsOrAwards = products.every(
    (product) =>
      product === EnumProducts.MULTIBENEFITS || product === EnumProducts.AWARDS
  );

  const isOnlyMultibenefitsOrCajuMais = products.every(
    (product) =>
      product === EnumProducts.MULTIBENEFITS || product === EnumProducts.CAJU_MAIS || product === EnumProducts.AWARDS
  );

  const hasExpenses = !!products?.includes(EnumProducts.CORP_EXPENSES);
  const employeesLess499 = employeesNumber && (employeesNumber >= 20 && employeesNumber <= 499)

  const goesToStep7Employee = employeesNumber && (employeesNumber >= 20 && employeesNumber <= 999)

  const goesToStep4 = employeesNumber &&
    employeesNumber < 20 &&
    (isMultibenefitsOrAwards || isMultipleWithMultibenefitsWithoutCiclos) 

  const goesToStep7 = 
    (goesToStep7Employee && (isOnlyMultibenefitsOrCajuMais || products.length > 1)) ||
    (employeesLess499 && hasExpenses)

  if(goesToStep4) return 3

  if(goesToStep7) return 6

  return 4
};

export function getFormFromLocalStorage() {
  const rawFormFromLocalStorage = localStorage.getItem(FORM_LOCAL_STORAGE_KEY) || "{}";
  const formFromLocalStorage: IFormFromLocalStorage = JSON.parse(rawFormFromLocalStorage);

  return formFromLocalStorage;
}

export function saveFieldsOnLocalStorage(values: FormikValues) {
  const formFromLocalStorage = getFormFromLocalStorage();

  localStorage.setItem(
    FORM_LOCAL_STORAGE_KEY,
    JSON.stringify({ ...formFromLocalStorage, ...values })
  );
}
